import React, { useReducer} from "react";
import UserContext from "./userContext";
import * as ACTIONS from "../../actions/actions";
import * as AuthReducer from "../../reducers/authReducer";
import { clearTokens} from "../../REST/requests";

const UserContextState = ({children, start}) => {

  const [stateAuthReducer, dispatchAuthReducer] =  useReducer(
    AuthReducer.AuthReducer,
    start
  );

  const handleLogin = (data) => {
    dispatchAuthReducer(ACTIONS.login(data));
  };

  const handleLogout = () => {
    dispatchAuthReducer(ACTIONS.logout());
    clearTokens();
  };

  return (
    <UserContext.Provider
      value={{
        isAuth: stateAuthReducer.isAuth,
        user: stateAuthReducer.user,
        error: stateAuthReducer.error,
        handleUserLogin: (data) => handleLogin(data),
        handleUserLogout: () => handleLogout()
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextState;